module.exports = __webpack_public_path__ + "static/img/productAnt-section2-icon2@2x.2aaa23f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productAnt-section2-icon2@2x.png
// module id = 63
// module chunks = 0